module.exports = require('buffer')



// WEBPACK FOOTER //
// ./node_modules/ws/node_modules/safe-buffer/browser.js